import { render, staticRenderFns } from "./realNameAuthenticationed.vue?vue&type=template&id=73420b26&scoped=true&"
import script from "./realNameAuthenticationed.vue?vue&type=script&lang=js&"
export * from "./realNameAuthenticationed.vue?vue&type=script&lang=js&"
import style0 from "./realNameAuthenticationed.vue?vue&type=style&index=0&id=73420b26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73420b26",
  null
  
)

export default component.exports